module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/backArrow-73238c0ffac5c722262ae70bf48527ef.svg";